import { render } from "./radiobutton-horizontal.html?vue&type=template&id=1fdcbe60&scoped=true&ts=true&external"
import script from "./radiobutton-horizontal.ts?vue&type=script&lang=ts&external"
export * from "./radiobutton-horizontal.ts?vue&type=script&lang=ts&external"

import "./radiobutton-horizontal.scss?vue&type=style&index=0&id=1fdcbe60&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdcbe60"]])

export default __exports__